import React from "react";
import { TbPhoneCall } from "react-icons/tb";
import { HiOutlineMail } from "react-icons/hi";
import { ROUTES_NAME } from "../../constants/routes";
import { Link } from "react-router-dom";

const TermsAndConditions = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-10 text-defaultText">
      <h1 className="text-3xl font-bold mb-6">📜 Terms & Conditions</h1>
      <p className="text-sm text-gray-500 mb-2">Effective Date: 01/04/2025</p>
      <p className="mb-4">
        Welcome to <strong>Edupro Hub</strong>! These Terms & Conditions
        (“Terms”) govern your access to and use of our platform, services,
        mobile applications, and website operated by Edupro Hub. By registering
        or using any of our services, you agree to comply with these Terms.
        Please read them carefully.
      </p>

      <Section number="1" title="Definitions">
        “We”, “Us”, “Our” refers to Edupro Hub.
        <br />
        “You”, “User”, “Institute” refers to any coaching center, administrator,
        teacher, or student using our services.
        <br />
        “Platform” means Edupro Hub’s web and mobile applications.
      </Section>

      <Section number="2" title="Eligibility">
        By using Edupro Hub, you confirm that:
        <ul className="list-disc list-inside pl-4">
          <li>
            You are at least 18 years old or authorized by a coaching institute.
          </li>
          <li>
            You have the authority to enter into these Terms on behalf of your
            institution (if applicable).
          </li>
        </ul>
      </Section>

      <Section number="3" title="Services Offered">
        Edupro Hub provides coaching centers with:
        <ul className="list-disc list-inside pl-4">
          <li>Real exam simulation tools</li>
          <li>LMS and ERP management tools</li>
          <li>Result processing and student dashboards</li>
          <li>Mobile app access for students and teachers</li>
        </ul>
        We reserve the right to add, modify, or remove services as needed.
      </Section>

      <Section number="4" title="Account Responsibilities">
        When you create an account with Edupro Hub:
        <ul className="list-disc list-inside pl-4">
          <li>Provide accurate, current, and complete information.</li>
          <li>Maintain confidentiality of your account.</li>
          <li>Do not share access or misuse the platform.</li>
        </ul>
        Edupro Hub is not liable for any unauthorized access due to negligence
        on your part.
      </Section>

      <Section number="5" title="User Conduct">
        You agree not to:
        <ul className="list-disc list-inside pl-4">
          <li>Use Edupro Hub for illegal purposes</li>
          <li>Interfere with the platform’s security or network</li>
          <li>Upload harmful content or malware</li>
          <li>Violate privacy laws with student data</li>
        </ul>
        Violating these may result in account termination.
      </Section>

      <Section number="6" title="Data Protection">
        We collect personal and academic information to operate our services
        effectively. All data is handled securely in accordance with our{" "}
        <Link
          to={ROUTES_NAME.PRIVACY_POLICY}
          className="text-primary-900 underline"
        >
          Privacy Policy
        </Link>
        .
      </Section>

      <Section number="7" title="Intellectual Property">
        All content, logos, and technology on the platform are the intellectual
        property of Edupro Hub. Do not copy or distribute without written
        permission.
      </Section>

      <Section number="8" title="Payment & Subscription">
        For paid services:
        <ul className="list-disc list-inside pl-4">
          <li>Pricing and plans are shown before subscribing.</li>
          <li>Non-payment may lead to suspension.</li>
          <li>Refunds follow our refund policy (contact support).</li>
        </ul>
      </Section>

      <Section number="9" title="Limitation of Liability">
        Edupro Hub is not responsible for:
        <ul className="list-disc list-inside pl-4">
          <li>System downtime or interruptions</li>
          <li>Inaccurate user-uploaded data</li>
          <li>Misuse by unauthorized users</li>
        </ul>
        Our liability is limited to the service fee you paid in the last 12
        months.
      </Section>

      <Section number="10" title="Termination">
        We may suspend or terminate your access if you violate these Terms. You
        may also close your account by contacting support.
      </Section>

      <Section number="11" title="Governing Law">
        These Terms are governed by Indian laws. Disputes will be handled in the
        courts of your local city/state.
      </Section>

      <Section number="12" title="Contact Us">
        Questions or concerns? Reach out to us:
        <ul className="list-none pl-4 mt-2">
          <p className="flex items-center gap-2">
            <HiOutlineMail className="text-lg text-primary-900" />
            Email:{" "}
            <Link
              to="mailto:info@eduprohub.in"
              className="text-primary-900 underline"
            >
              info@eduprohub.in
            </Link>
          </p>
          <p className="flex items-center gap-2">
            <TbPhoneCall className="text-lg text-primary-900" />
            Phone:{" "}
            <Link to="tel:+919179619315" className="text-primary-900 underline">
              +91-91796 19315
            </Link>
          </p>{" "}
        </ul>
      </Section>
    </div>
  );
};

const Section = ({ number, title, children }) => (
  <div className="mb-6">
    <h2 className="text-xl font-semibold mb-2">
      {number}. {title}
    </h2>
    <p className="text-gray-700">{children}</p>
  </div>
);

export default TermsAndConditions;
